import { CHAT_TYPE } from "../myComponents/Chatframe"

/**
 * 流式聊天服务
 */
export class ChatService {
    constructor(appId,token) {
        this.appId = appId
        this.token=token
        this.state = 0  //0-未连接  1-连接中  2-连接成功  3-连接失败

    }
    disconnect(){
        this.websocket && this.websocket.close()
    }
    /**
     * 连接
     */
    connect(callback) {
        console.log('----------连接websocket')
        if(this.state==1){
            console.log('已经正在连接中')
            return
        }
        this.state = 1
        this.websocket = new WebSocket(process.env.CHAT_FLOW_SERVER + '/' + `${this.token}`)
        this.websocket.onopen = () => {
            console.log('websocket connect success')
            this.state = 2
            callback && callback(null, '连接成功')
            if(this.heartHandle){
                clearInterval(this.heartHandle)
            }
            this.heartHandle = setInterval(()=>{
                if(this.state == 2){
                    this.websocket.send(JSON.stringify({
                        'heart':Date.now()
                    }));
                }
                
            },15000)
        }
        this.websocket.onerror = (err) => {
            console.error('websocket connect error', err)
            callback && callback('连接失败')
        }
        this.websocket.onmessage = (msg) => {
            // console.log('websocket message', msg.data)
            if (this.respCallback) {
                this.respCallback(JSON.parse(msg.data))
            }
        }
        this.websocket.onclose = (reason) => {
            console.log('websocket close', reason)
            this.state = 0
            //尝试重连
            setTimeout(()=>{
                this.connect(( msg)=>{
                    
                })
            },5000)
        }
        setInterval(()=>{

        },5000)
        return this
    }
    /**
     * 询问
     * @param {*} question 
     * @param {*} openViseme 
     * type:1-文字  2-语音
     */
    ask(questionID, question, type, param, callback) {
        if (this.state == 0 || this.state ==3) {
            return callback('服务器还未连接')
        }
        console.log('-----token',this.token)
        let askData={
            h:[],
            q:'',
            qu:''
        }
        if(type==CHAT_TYPE.TEXT){
            askData.q = question
        }
        else if(type==CHAT_TYPE.VOICE){
            askData.qu= question
        }
        this.websocket.send(JSON.stringify(askData))
        this.respCallback = callback
    }

}


// WEBPACK FOOTER //
// ./src/utils/chatService.js